var React = require('react');

function UiMenu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Menu"),React.createElement("path",{"d":"M22.6,13.4c0,0.5-0.4,0.9-0.9,0.9H0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h20.8\n\tC22.2,12.5,22.6,12.9,22.6,13.4z M21.7,6.3H0.9C0.4,6.3,0,6.7,0,7.2C0,7.7,0.4,8,0.9,8h20.8c0.5,0,0.9-0.4,0.9-0.9\n\tC22.6,6.7,22.2,6.3,21.7,6.3z M0,0.9C0,0.4,0.4,0,0.9,0h20.8c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H0.9C0.4,1.8,0,1.4,0,0.9\n\tC0,0.9,0,0.9,0,0.9z","key":1})]);
}

UiMenu.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 22.6 14.3","style":{"enableBackground":"new 0 0 22.6 14.3"},"xmlSpace":"preserve"};

module.exports = UiMenu;

UiMenu.default = UiMenu;
